import { IonIcon, useIonModal } from "@ionic/react";
import styles from "./DeviceTransitPolicyTile.module.css";
import { addOutline } from "ionicons/icons";
import AddDoorPolicyModal from "../modals/AddDoorPolicyModal";
import { useCommonTranslation } from "../hooks/useTranslation";

interface Props {
    deviceId: string;
}

const DeviceTransitPolicyAddButton: React.FC<Props> = ({ deviceId }) => {
    const [presentAddModal, dismissAddModal] = useIonModal(AddDoorPolicyModal, {
        deviceId,
        dismiss: (data: string, role: string) => dismissAddModal(data, role)
    });
    const { t: tCommon } = useCommonTranslation();

    return (
        <button className={`${styles.tile} ${styles.add}`} onClick={() => presentAddModal({
            presentingElement: document.getElementsByTagName('ion-router-outlet')[0]
        })}>
            <IonIcon icon={addOutline} />
            <label>{tCommon('buttons.add')}</label>
        </button>
    );
};

export default DeviceTransitPolicyAddButton;
